// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"452":"1fcfc14b","833":"1fcfc14b"}[chunkId] + ".chunk.css";
};